import { render, staticRenderFns } from "./addindTree.vue?vue&type=template&id=124f65a0&scoped=true&"
import script from "./addindTree.vue?vue&type=script&lang=js&"
export * from "./addindTree.vue?vue&type=script&lang=js&"
import style0 from "./addindTree.vue?vue&type=style&index=0&id=124f65a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f65a0",
  null
  
)

export default component.exports